import { Row, Col } from "react-flexbox-grid";
import { Logo, Loading as Spin } from "components";
import styled from "styled-components";

const Loading = styled(Row)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #fff;
  z-index: 9999999999;
  opacity: 1;
  visibility: visible;
  transition: all 1s ease-out 0.5s;
  margin: 0;
  p {
    font-size: 16px;
    margin: -10px 0 1em;
    font-weight: 400;
    color: #7c4dff;
  }

  &.inActive {
    opacity: 0;
    visibility: hidden;
  }
`;

export const Loader = ({ className, message }) => {
  return (
    <Loading id="loading" center="xs" middle="xs" className={className}>
      <Col md={12}>
        <Logo isNotLink />
        <p>{message}</p>
        <Spin />
      </Col>
    </Loading>
  );
};
